import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PackersMoversService } from "../service/packers-movers.service";
import { Location } from '@angular/common';
@Component({
  selector: "app-view-users-details",
  templateUrl: "./view-users-details.component.html",
  styleUrls: ["./view-users-details.component.sass"],
})
export class ViewUsersDetailsComponent implements OnInit {
  id: string = "";
  userDetails: any = {};

  constructor(
    private route: ActivatedRoute,
    private packersMoversService: PackersMoversService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.id = params["id"];

      if (this.id) {
        this.getUserDetailsById();
      }
    });
  }

  getUserDetailsById() {
    this.packersMoversService.getUserRequirementById(this.id).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          this.userDetails = response.data;
        }
      },
      (error) => {
        console.log(error);
      },
    );
  }

  goBack() {
  this.location.back();
}
}
